import { Trans } from 'react-i18next';
import { MARKET } from '@/common/constants/markets';
import { useMarket } from '@/web/hooks/useMarket';
import { Text, TextAction } from '@coverflex-tech/hypernova';

export const InsuranceUpgradePlanGeneralConditions = ({
  href,
}: TInsuranceUpgradePlanGeneralConditionsProps) => {
  const { slug } = useMarket();
  return (
    <Text>
      {slug === MARKET.PT ? (
        <>
          <Trans i18nKey="dashboard.insurance.upgrade_plan.step.choose_plan.conditions_sentence.description" />
          &nbsp;
          {href && (
            <TextAction as="a" href={href} target="_blank" rel="noreferrer">
              <Trans i18nKey="dashboard.insurance.upgrade_plan.step.choose_plan.conditions_sentence.link" />
            </TextAction>
          )}
        </>
      ) : (
        <Trans i18nKey="dashboard.insurance.plan.step.choose_plan.conditions_sentence.description" />
      )}
    </Text>
  );
};

export type TInsuranceUpgradePlanGeneralConditionsProps = {
  href?: string;
};
